enum FORM_NAMES {
  junior = 'junior',
  middle = 'middle',
  senior = 'senior',
  others = 'others',
  numberOfGuests = 'number_of_guests',
  numberOfPets = 'number_of_pets',
  group_type = 'group_type',
  guests = 'guests',
}

enum MODAL_FORMS {
  numberOfGuests = 'number_of_guests',
  reservationType = 'reservation_type',
  confirmLeaderGuest = 'confirm_leader_guest',
}

const COUNTER_ROW_CLASS = 'rounded-2xl bg-[var(--chekin-color-white)] px-4 py-3';
const COUNTER_GROUPED_ROW_CLASS = 'py-3';

export {FORM_NAMES, MODAL_FORMS, COUNTER_GROUPED_ROW_CLASS, COUNTER_ROW_CLASS};
